import { pluralize } from '../../../system/util/pluralize';
export var formatActionSheetLabel = function formatActionSheetLabel(selectedRows) {
  return selectedRows.length ? "".concat(selectedRows.length, " ").concat(pluralize(selectedRows.length, 'item', 'items'), " selected") : undefined;
};